import { render } from "./AddPermissionGroup.vue?vue&type=template&id=d0f3205a&scoped=true&ts=true"
import script from "./AddPermissionGroup.vue?vue&type=script&lang=ts"
export * from "./AddPermissionGroup.vue?vue&type=script&lang=ts"

import "./AddPermissionGroup.vue?vue&type=style&index=0&id=d0f3205a&scoped=true&lang=css"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f3205a"]])

export default __exports__